module.exports = "/src/views/player/help/images/lsc1.jpg";